import { getHeaders } from '@mummssoftware/utils/utils';
import moment from 'moment-timezone';
import {
  APPROVAL_GRID_COLUMN_KEY,
  APPROVAL_GRID_FILTER_KEY,
  APPROVAL_GRID_SORT_KEY,
  APPROVAL_DETAIL_GRID_COLUMN_KEY,
  APPROVAL_DETAIL_GRID_FILTER_KEY,
  APPROVAL_DETAIL_GRID_SORT_KEY,
  APPROVAL_VIEW_DETAIL,
} from '../../../constants';

export const daysFilterOptions = [
  {
    displayKey: 'equalsDays',
    displayName: 'Equals (in days)',
    test: (fV, cV) => fV === cV,
  },
  {
    displayKey: 'notEqualsDays',
    displayName: 'Not equals (in days)',
    test: (fV, cV) => fV !== cV,
  },
  'lessThan',
  'lessThanOrEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'inRange',
];

export const dateComparator = (filterLocalDateAtMidnight, cellValue) => {
  const date = moment.utc(cellValue);
  if (moment(date).isBefore(filterLocalDateAtMidnight, 'day')) {
    return -1;
  } else if (moment(date).isAfter(filterLocalDateAtMidnight, 'day')) {
    return 1;
  }
  return 0;
};

export const APPROVAL_LISTING = 'APPROVAL_LISTING';
export const APPROVAL_DETAIL_LISTING = 'APPROVAL_DETAIL_LISTING';
export const CERT_LISTING = 'CERT_LISTING';

export const defaultFilterModel = {};
export const defaultCertSortModel = [
  {
    colId: 'daysUntilDue',
    sort: 'asc',
  },
];

export const defaultApprovalSortModel = [];

// OP-31894: "By Order" view defaults to oldest unsigned order first
export const defaultApprovalDetailSortModel = [
  {
    colId: 'orderDate',
    sort: 'asc',
  },
];

export const defaultCertColumnsModel = [
  'clinicalOutUp',
  'daysUntilDue',
  'teamName',
  'pId',
  'firstName',
  'lastName',
  'payer',
  'electionNumber',
  'certDueDate',
  'f2f',
  'hospiceVerbalDate',
  '0',
];
export const defaultApprovalColumnsModel = [
  'clinicalOutUp',
  'pId',
  'patientFirstname',
  'patientLastname',
  'numUnreconciledMeds',
  'admissions',
  'dc',
  'loc',
  'standing',
  'services',
];

export const defaultApprovalDetailColumnsModel = [
  'spacer',
  'pId',
  'patientName',
  'doctorName',
  'orderType',
  'orderDate',
];

// OP-31894: grid state (columns / filter / sort) is saved per view mode so
// switching between "By Patient" and "By Order" restores each view's own layout.
export const getApprovalGridStorageKeys = (viewMode) =>
  viewMode === APPROVAL_VIEW_DETAIL
    ? {
        columnKey: APPROVAL_DETAIL_GRID_COLUMN_KEY,
        filterKey: APPROVAL_DETAIL_GRID_FILTER_KEY,
        sortKey: APPROVAL_DETAIL_GRID_SORT_KEY,
        listing: APPROVAL_DETAIL_LISTING,
        defaultSortModel: defaultApprovalDetailSortModel,
        defaultColumnsModel: defaultApprovalDetailColumnsModel,
      }
    : {
        columnKey: APPROVAL_GRID_COLUMN_KEY,
        filterKey: APPROVAL_GRID_FILTER_KEY,
        sortKey: APPROVAL_GRID_SORT_KEY,
        listing: APPROVAL_LISTING,
        defaultSortModel: defaultApprovalSortModel,
        defaultColumnsModel: defaultApprovalColumnsModel,
      };

const getDefaultSortModel = (model) => {
  if (model === CERT_LISTING) return defaultCertSortModel;
  if (model === APPROVAL_DETAIL_LISTING) return defaultApprovalDetailSortModel;
  return defaultApprovalSortModel;
};

export const checkDefaultModels = (sortModel, filterModel, model) => {
  const defaultSortModel = getDefaultSortModel(model);
  const isDefaultSort =
    sortModel.length === defaultSortModel.length &&
    sortModel.filter(
      ({ colId, sort }, i) =>
        defaultSortModel[i].colId === colId &&
        defaultSortModel[i].sort === sort,
    ).length === defaultSortModel.length;
  const isDefaultFilter = filterModel ? !Object.keys(filterModel).length : true;
  return { isDefaultSort, isDefaultFilter };
};

export const certCellValueGetter = (
  paramName,
  noFirstElection,
  additionalTests,
) => (params) => {
  if (params.data[paramName]) {
    return true;
  } else if (
    (noFirstElection && params.data.electionNumber !== 1) ||
    (additionalTests &&
      additionalTests.filter(([k, v]) => params.data[k] === v).length)
  ) {
    return 'not needed';
  }
  return false;
};

export const fetchPimreaderVisitDetails = async (
  keycloak,
  agency,
  patientNumber,
  patientId,
  userNumber,
  visitID,
) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getvisits?agency=${agency}`;
  authProxyUrl += `&p_patientnumber=${patientNumber}`;
  authProxyUrl += `&p_patient_id=${patientId}`;
  authProxyUrl += `&p_personnumber=`;
  authProxyUrl += `&p_person_id=`;
  authProxyUrl += `&p_fromdate=`;
  authProxyUrl += `&p_todate=`;
  authProxyUrl += `&p_visitstatus=`;
  authProxyUrl += `&p_latest=false`;
  authProxyUrl += `&p_patientvisit_id=${visitID}`;
  authProxyUrl += `&p_siteoffice=`;
  authProxyUrl += `&p_mindurationmins=`;
  authProxyUrl += `&p_minchartingmins=`;
  authProxyUrl += `&p_attribute_ids=`;

  const response = await fetch(authProxyUrl, {
    headers,
    credentials: 'same-origin',
  });
  const visit = await response.json();

  return visit[0];
};
